<script setup lang="ts">
import type { File } from '~/types/api'

defineProps<{
  images: File[]
}>()

const { t } = useI18n()
</script>

<template>
  <section class="py-16">
    <div class="mx-auto px-4">
      <div class="text-center">
        <h1 class="mb-8 text-xl">
          {{ t('base.news.gallery') }}
        </h1>
        <UiGalleryCarousel :images="images" />
      </div>
    </div>
  </section>
</template>
